<template>
  <div>
    <ts-card>
      <div
        class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
      >
        <small class="ts-text-sm text-warning">
          <i class="fas fa-exclamation-triangle"></i>
          {{ $t('studentCardActivator.changeStatus') }}
        </small>
        <ts-modal-close-button />
      </div>
    </ts-card>
    <ts-card-wrapper>
      <ts-loading-banner :loading="loadingPreData">
        <form>
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group m-b-10">
                <label class="col-form-label control-label required">
                  {{ $t('studentCardActivator.status') }}
                </label>
                <div>
                  <select class="form-control" v-model.number="model.status_id">
                    <option value disabled selected style="display: none;">{{
                      $t('select')
                    }}</option>
                    <option
                      v-for="(status, index) in cardStatus"
                      :key="index"
                      :value="status.card_status_id"
                      >{{ status.card_status }}</option
                    >
                  </select>
                  <div class="invalid-feedback" v-if="errors.has('reason')">
                    {{ errors.first('reason') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group m-b-10">
                <label class="col-form-label control-label required">
                  {{ $t('studentCardActivator.reason') }}
                </label>
                <div>
                  <textarea
                    rows="3"
                    class="form-control"
                    v-model="model.reason"
                    :class="{ 'is-invalid': errors.has('reason') }"
                  ></textarea>
                  <div class="invalid-feedback" v-if="errors.has('reason')">
                    {{ errors.first('reason') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row ts-mt-6">
            <div class="col-sm-12 col-lg-12 col-md-12 text-right">
              <ts-button
                class="btn-sm"
                @click.prevent="$emit('close')"
                :disabled="saving"
                >{{ $t('no') }}</ts-button
              >
              <ts-button
                color="primary"
                class="ml-2 btn-sm"
                :waiting="saving"
                @click.prevent="submit"
                >{{ $t('yes') }}</ts-button
              >
            </div>
          </div>
        </form>
      </ts-loading-banner>
    </ts-card-wrapper>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'

export default {
  props: ['data'],
  name: 'change-status-form',
  data() {
    return {
      model: {
        student_id: '',
        status_id: '',
        serial_card: '',
        reason: ''
      },
      errors: new Errors(),
      saving: false,
      loadingPreData: false
    }
  },
  computed: {
    ...mapState('studentCardActivator', ['cardStatus'])
  },
  created() {
    this.fetchResourceBeforeCreate()
  },
  methods: {
    fetchResourceBeforeCreate() {
      this.loadingPreData = true
      this.$store
        .dispatch('studentCardActivator/dataBeforeCreate')
        .then(() => {
          this.loadingPreData = false
          this.model.student_id = this.data.student_id
          this.model.status_id = this.data.status_id
          this.model.serial_card = this.data.serial_card
        })
        .catch(error => {
          this.loadingPreData = false
          this.$toasted.error(error.message)
        })
    },
    submit() {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('studentCardActivator/change', this.model)
        .then(response => {
          return this.$store
            .dispatch('studentCardActivator/fetch')
            .then(res => {
              this.saving = false
              this.$toasted.success(response.message)
              this.$emit('close')
              return Promise.resolve(res)
            })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.saving = false
        })
    }
  }
}
</script>
